module.exports = __webpack_public_path__ + "img/empty-user.9ef50c51.svg";